import { Avatar, Box, Grid, Table, styled } from '@mui/material';

export const FlowChecksTable = styled(Table)(({ theme }) => ({
  tableLayout: 'fixed',
  marginBottom: theme.spacing(1)
}));

export const CascoCrossCheckContent = styled(Grid)(({ theme }) => ({
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: theme.spacing(1),
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: theme.spacing(2)
  }
}));

export const ComparisonContainer = styled(Grid, { shouldForwardProp: prop => prop !== 'existing' })(({ theme, existing }) => ({
  paddingBlock: theme.spacing(0.5),
  ...(existing && {
    paddingRight: theme.spacing(2),
    borderRight: '1px solid rgba(0, 0, 0, 0.1)'
  }),
  ...(!existing && {
    paddingLeft: theme.spacing(2),
    borderLeft: '1px solid rgba(0, 0, 0, 0.1)'
  })
}));

export const CascoConventionName = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  fontSize: '17px'
}));

export const CascoConventionWrapper = styled(Grid)(({ theme }) => ({
  '& strong': {
    marginRight: theme.spacing(0.5)
  }
}));

export const CascoLegendContentWrapper = styled('div')(({ theme }) => ({
  '& strong': {
    marginRight: theme.spacing(0.5)
  }
}));

export const CrossCheckTitleContainer = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  color: theme.palette.common.white,
  fontWeight: theme.typography.fontWeightBold,
  paddingBlock: theme.spacing(1)
}));

export const CrossCheckTitle = styled('div')(() => ({
  flexBasis: '50%',
  textAlign: 'center'
}));

export const DirectSettlementAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  backgroundColor: theme.palette.warning.main,
  fontSize: '0.7rem !important'
}));

export const RcaComparisonTitle = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(2),
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase'
}));

export const RcaComparisonDetail = styled(Grid, { shouldForwardProp: prop => !['changed', 'changedColor'].includes(prop) })(
  ({ theme, changed, changedColor }) => ({
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '5px',
    textAlign: 'center',
    borderColor: changed ? theme.palette[changedColor].main : theme.palette.common.black,
    paddingBlock: theme.spacing(0.5),
    display: 'flex',
    gap: theme.spacing(0.5)
  })
);

export const ComparisonCard = styled(Grid)(({ theme }) => ({
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(2),
  borderRadius: '10px',
  boxShadow: theme.shadows[3]
}));

export const CascoComparisonTitle = styled(Grid, { shouldForwardProp: prop => !['changed', 'changedColor'].includes(prop) })(
  ({ theme, changed, changedColor }) => ({
    color: changed ? theme.palette[changedColor].main : theme.palette.common.black,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1),
    fontSize: '17px'
  })
);

export const CascoComparisonLabel = styled('span')(({ theme }) => ({
  color: theme.palette.grey[500]
}));

export const CascoComparisonDetail = styled('span', { shouldForwardProp: prop => !['changed', 'changedColor'].includes(prop) })(
  ({ theme, changed, changedColor }) => ({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    ...(changed && {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette[changedColor].main
    })
  })
);

export const CascoNoQuotationWrapper = styled(Box, { shouldForwardProp: prop => prop !== 'color' })(({ theme, color }) => ({
  fontWeight: theme.typography.fontWeightBold,
  width: '100%',
  color: theme.palette[color].main,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
